import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Switch, Route, Redirect, Link } from 'react-router-dom'
import AppLayout from '../layout';
import { appUrl, hasPermission, notFoundImage } from '../utils';
import { ProfileView } from '../views/profile';
import { TypeEventView } from '../views/type-event';
import { EventView } from '../views/event';
import { WorkerView } from '../views/worker';
import { EscanerView } from '../views/escaner';
import { ReportEventView } from '../views/report-event/report-event-view/ReportEventView';
import { SaleView } from '../views/sale';
import HomeView from '../views/home'
import CartView from '../views/cart'
import EventDetail from '../views/event-detail'
import CartSuccess from '../views/cart/components/CartSuccess'
import CartError from '../views/cart/components/CartError'
import { getSessionCustomer } from '../context/slices/session-customer';
import LoadingIcon from '../components/loading/LoadingIcon';
import { CouponView } from '../views/coupon';
import { ProductView } from '../views/product';
import { BreakBoxWorkerView } from '../views/report/break-box/BreakBoxWorkerView';
import { ReporteGeneralView } from '../views/report/general/ReporteGeneralView';
import { ReporteDetalladoView } from '../views/report/detail/ReporteDetalladoView';
import { ReporteVentasMensualView } from '../views/report/monthly/ReporteVentasMensualView';
import Us from '../views/home/Us';
import Contact from '../views/home/Contact';
import MisTickets from '../views/mis-tickets';
import Layout from '../views/home/theme/Layout';
import NotFound from '../views/auth/not-found';
import CustomerAuth from '../views/customer-auth';
import ProductosCatalogView from '../views/productos-cliente/ProductosCatalogView';
import CompraProductosView from '../views/compra-productos/CompraProductosView';
import CarritoProductosSuccess from '../views/carrito-productos/CarritoProductosSuccess';
import CarritoProductosError from '../views/carrito-productos/CarritoProductosError';
import WebVisitsView from '../views/report/web-visits/WebVisitsView';
import MetaPixelPageView from '../components/meta-pixel/MetaPixelPageView';

const RoutesAuthenticated = () => {
  const { permissions, main_profile } = useSelector(store => store.session);
  const { sessionValidated, isCustomer, type } = useSelector(state => state.session)

  const validatePermission = (module) => {
    return hasPermission({ permissions, module });
  }

  const dispatch = useDispatch();
  const { id_customers_reservation_event_zone } = useSelector(state => state.sessioncustomer)

  useEffect(() => {
    if (!(sessionValidated && isCustomer)) {
      dispatch(getSessionCustomer());
    }
  }, [dispatch, sessionValidated, isCustomer, type])

  if (!id_customers_reservation_event_zone) {
    return <LoadingIcon />
  }

  return <BrowserRouter>
    <MetaPixelPageView />
    <Switch>
      {validatePermission('visitas-web') && <Route path={appUrl({ url: '/visitas-web' })} exact>
        <div className="wv-screen"><AppLayout title="Visitas Web" page="visitas-web" hideTop><WebVisitsView /></AppLayout></div>
      </Route>}
      {validatePermission('perfiles') && <Route path={appUrl({
        url: '/perfiles'
      })} exact>
        <AppLayout title="Roles" page="perfiles">
          <ProfileView />
        </AppLayout>
      </Route>}
      {validatePermission('trabajadores') && <Route path={appUrl({
        url: '/trabajadores'
      })} exact>
        <AppLayout title="Trabajadores" page="trabajadores">
          <WorkerView />
        </AppLayout>
      </Route>}
      {validatePermission('tipo-eventos') && <Route path={appUrl({
        url: '/tipo-eventos'
      })} exact>
        <AppLayout title="Tipos de Eventos" page="tipo-eventos">
          <TypeEventView />
        </AppLayout>
      </Route>}
      {validatePermission('eventos') && <Route path={appUrl({
        url: '/eventos'
      })} exact>
        <AppLayout title="Eventos" page="eventos">
          <EventView />
        </AppLayout>
      </Route>}
      {validatePermission('escaner') && <Route path={appUrl({
        url: '/escaner'
      })} exact>
        <AppLayout title="Escáner" page="escaner" hideTop>
          <EscanerView />
        </AppLayout>
      </Route>}
      {validatePermission('reporte-eventos') && <Route path={appUrl({
        url: '/reporte-eventos'
      })} exact>
        <AppLayout title="Reporte Eventos" page="reporte-eventos">
          <ReportEventView />
        </AppLayout>
      </Route>}
      {validatePermission('ventas') && <Route path={appUrl({
        url: '/ventas'
      })} exact>
        <AppLayout title="Ventas" page="ventas">
          <SaleView />
        </AppLayout>
      </Route>}
      {validatePermission('cupones') && <Route path={appUrl({
        url: '/cupones'
      })} exact>
        <AppLayout title="Cupones" page="cupones">
          <CouponView />
        </AppLayout>
      </Route>}
      {validatePermission('productos') && <Route path={appUrl({
        url: '/productos'
      })} exact>
        <AppLayout title="Productos" page="productos">
          <ProductView />
        </AppLayout>
      </Route>}
      {validatePermission('corte-de-caja') && <Route path={appUrl({
        url: '/corte-de-caja'
      })} exact>
        <AppLayout title="Corte de Caja" page="corte-de-caja">
          <BreakBoxWorkerView />
        </AppLayout>
      </Route>}
      {validatePermission('reporte-general') && <Route path={appUrl({
        url: '/reporte-general'
      })} exact>
        <AppLayout title="Reporte General" page="reporte-general">
          <ReporteGeneralView />
        </AppLayout>
      </Route>}
      {validatePermission('reporte-evento-detallado') && <Route path={appUrl({
        url: '/reporte-evento-detallado'
      })} exact>
        <AppLayout title="Reporte Evento Detallado" page="reporte-evento-detallado">
          <ReporteDetalladoView />
        </AppLayout>
      </Route>}
      {validatePermission('reporte-ventas-mensual') && <Route path={appUrl({
        url: '/reporte-ventas-mensual'
      })} exact>
        <AppLayout title="Ventas Mensuales" page="reporte-ventas-mensual">
          <ReporteVentasMensualView />
        </AppLayout>
      </Route>}

      <Route path={appUrl({
        url: '/login'
      })} exact>
        <Redirect to={appUrl({
          url: '/' + main_profile
        })} />
      </Route>

      <Route path={appUrl({
        url: '/not-found'
      })} exact>
        <div className="not-found-container">
          <NotFound imageNotFound={notFoundImage()}
            backUrl={appUrl({
              url: '/' + main_profile
            })}
            Link={Link}
          />
        </div>
      </Route>

      <Route path={appUrl({
        url: '/'
      })} exact>
        <HomeView />
      </Route>
      <Route path={appUrl({
        url: '/evento/:slugEvent/:zoneId?'
      })} exact>
        <EventDetail />
      </Route>
      <Route path={appUrl({
        url: '/carrito'
      })} exact>
        <CartView />
      </Route>
      <Route path={appUrl({
        url: '/carrito/success'
      })} exact>
        <CartSuccess />
      </Route>
      <Route path={appUrl({
        url: '/carrito/error-pago'
      })} exact>
        <CartError />
      </Route>
      <Route path={appUrl({
        url: '/nosotros'
      })} exact>
        <Us />
      </Route>
      <Route path={appUrl({
        url: '/contacto'
      })} exact>
        <Contact />
      </Route>
      <Route path={appUrl({
        url: '/cuenta/login'
      })} exact>
        <CustomerAuth />
      </Route>
      <Route path={appUrl({
        url: '/cuenta/registro'
      })} exact>
        <CustomerAuth />
      </Route>
      <Route path={appUrl({
        url: '/mis-tickets'
      })} exact>
        <Layout title="Mis Tickets" page="mis-tickets">
          <MisTickets />
        </Layout>
      </Route>
      <Route path={appUrl({
        url: '/productos'
      })} exact>
        <Layout title="Productos" page="productos">
          <ProductosCatalogView />
        </Layout>
      </Route>
      <Route path={appUrl({
        url: '/compra-productos'
      })} exact>
        <Layout title="Compra de Productos" page="compra-productos">
          <CompraProductosView />
        </Layout>
      </Route>
      <Route path={appUrl({
        url: '/carrito-productos'
      })} exact>
        <Redirect to={appUrl({ url: '/productos' })} />
      </Route>
      <Route path={appUrl({
        url: '/carrito-productos/success'
      })} exact>
        <CarritoProductosSuccess />
      </Route>
      <Route path={appUrl({
        url: '/carrito-productos/error-pago'
      })} exact>
        <CarritoProductosError />
      </Route>

      <Route>
        <Redirect to={appUrl({
          url: '/not-found'
        })} />
      </Route>
    </Switch>
  </BrowserRouter>
}

export default RoutesAuthenticated